import * as ko from 'knockout'
import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import { MatchedFieldSummaryResults } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummaryResults'
import ObservableDogFinisher from '../../../Model/Observables/ObservableDogFinisher'
import ObservableResultsPage from '../../../Model/Observables/ObservableResultsPage'
import BaseFinisherViewModel from '../BaseFinisherViewModel'

export interface Params {
  raceInformation: ObservableResultsPage
  finisher: ObservableDogFinisher
  showField: boolean
}

export class DogFinisherViewModel extends BaseFinisherViewModel {
  public stripes: ko.ObservableArray<number>
  public stripeClass: (arg: number) => string
  public numberOfFinishersInRace: ko.PureComputed<number>
  public MatchedFieldSummaryResults = MatchedFieldSummaryResults
  public MatchedFieldSummary = MatchedFieldSummary

  constructor(params: Params) {
    super(params)

    this.stripes = ko.observableArray<number>([])
    for (let i = 1; i <= params.finisher.stripeCount(); ++i) {
      this.stripes.push(i)
    }
    this.stripeClass = stripe => 'stripe-' + stripe
    this.numberOfFinishersInRace = ko.pureComputed(
      () => params.raceInformation.raceFinishers.finishers().length
    )
  }
}
